import { render, staticRenderFns } from "./change_size.vue?vue&type=template&id=437490d4&"
import script from "./change_size.vue?vue&type=script&lang=js&"
export * from "./change_size.vue?vue&type=script&lang=js&"
import style0 from "./change_size.vue?vue&type=style&index=0&id=437490d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports